import React, { Component } from 'react'
import { Row, Col, Breadcrumb, Spin, Pagination, Drawer, Carousel, Card, Icon } from 'antd'
import { Link } from 'react-router-dom'
import { app, api, config } from '../../app'
import '../../css/bottomMenu.css'
import Head from '../../components/Head'
import Footer from '../../components/Footer'

class BNProAuthor extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dl_loading: false,
            submenu: [],
            data_loading: false,
            detail_visible: false,
            detail_loading: false,
            info: {},
            goodList: [],
            sel_menu: null,
            page: 1,
            total: 0
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleMenus()
        await this.handleAuthorPro(1)
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 菜单数据
     * @returns {Promise<void>}
     */
    handleMenus = async () => {
        let { flag, data, msg } = await app.post(api.BottomMenuClasslisting)
        const state = { dl_loading: false }
        if (flag === 1) {
            state.submenu = data
            state.sel_menu = data[0].id
        } else {
            app.alert(msg, 'error')
        }
        await this.setData(state)
    }

    /**
     * 授权产品
     * @param page
     * @returns {Promise<void>}
     */
    handleAuthorPro = async (page) => {
        const state = { data_loading: true, goodList: [] }
        if (page) {
            state.page = page
        } else {
            page = this.state.page
        }
        await this.setData(state)
        const { sel_menu } = this.state
        let { flag, data, total } = await app.post(api.BottomMenuMallListing, {
            class_id: sel_menu,
            page,
        })
        await app.sleep()
        if (this.state.page === page && sel_menu === this.state.sel_menu) {
            if (flag === 1) {
                await this.setData({
                    goodList: data,
                    total: parseInt(total || 0),
                    data_loading: false
                })
            } else {
                // app.alert(msg, 'error')
                await this.setData({ total: 0, data_loading: false })
            }
        }
    }

    /**
     * 打开详情
     * @param mall_id
     * @returns {Promise<void>}
     */
    handleOpenDetail = async (mall_id) => {
        await this.setData({ detail_visible: true, detail_loading: true })
        let { flag, data, msg } = await app.post(api.BottomMenuMallDetails, { mall_id })
        const state = { detail_loading: false }
        if (flag === 1) {
            state.info = data
        } else {
            app.alert(msg, 'error')
        }
        await this.setData(state)
    }

    handleToMall = (id) => {
        if (app.getToken()) {
            this.props.history.push('/mall/detail/' + id)
        } else {
            this.props.history.push('/login')
        }
    }

    render () {
        let { submenu, sel_menu, data_loading, goodList, page, total, dl_loading, detail_visible, info, detail_loading } = this.state
        return (
            <div className="bottom-menu">
                <div className="bm-head">
                    <Head history={this.props.history} center height="auto"/>
                </div>
                <div className="bm-content">
                    <div className="bmc-b">
                        <Breadcrumb separator=">">
                            <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
                            <Breadcrumb.Item>{this.props.match.params.name}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="bmc-c">
                        <Spin spinning={dl_loading} size="large">
                            <Row type="flex" justify="space-between" align="bottom">
                                <div className="bmcc-ltab">{this.props.match.params.name}</div>
                                <div>
                                    {
                                        submenu.map((sub, i) => {
                                            if (sub.id === sel_menu) {
                                                return (
                                                    <div title={sub.class_name} key={i}
                                                         className='bmcc-tab-sel'>{sub.class_name}</div>
                                                )
                                            } else {
                                                return (
                                                    <div title={sub.class_name} key={i} className="bmcc-tab"
                                                         onClick={async () => {
                                                             await this.setData({ sel_menu: sub.id })
                                                             await this.handleAuthorPro(1)
                                                         }}>{sub.class_name}</div>
                                                )
                                            }
                                        })
                                    }
                                </div>
                            </Row>
                            <div className="bncc-c">
                                <Spin spinning={data_loading} size="large">
                                    <Row className="cc-items" gutter={15}>
                                        {
                                            data_loading ? null :
                                                goodList && goodList.length > 0 ? goodList.map(g => {
                                                    return (
                                                        <Col span={6} key={g.id}>
                                                            <div className="cc-good" title={g.ppename}
                                                                 onClick={() => this.handleOpenDetail(g.id)}>
                                                                <div className="cg-cover">
                                                                    <img src={config.imgUrl + g.localpath} alt=""/>
                                                                </div>
                                                                <div className="cg-title">{g.ppename}</div>
                                                            </div>
                                                        </Col>
                                                    )
                                                }) : (<div style={{ textAlign: 'center', color: '#999' }}>暂无产品</div>)
                                        }
                                    </Row>
                                    <div className="cc-page">
                                        <Pagination hideOnSinglePage={true} current={page}
                                                    total={data_loading ? 0 : total} pageSize={20}
                                                    onChange={this.handleAuthorPro}/>
                                    </div>
                                </Spin>
                            </div>
                        </Spin>
                    </div>
                </div>
                <Footer/>
                <Drawer
                    title={info.ppename}
                    placement="right"
                    onClose={() => this.setData({ detail_visible: false })}
                    visible={detail_visible}
                    width={600}
                    zIndex={1001}
                    bodyStyle={{ overflowY: 'auto', height: 'calc(100% - 55px)', padding: 20 }}
                    destroyOnClose={true}
                    className="product-author-detail-drawer"
                >
                    <Spin spinning={detail_loading} size="large">
                        <Carousel autoplay>
                            {
                                info.localpath ? info.localpath.split(':::').map((p, i) => (
                                    <div key={'pad-img-' + i} className="pad-img">
                                        <img src={config.imgUrl + p} alt=""/>
                                    </div>
                                )) : <div>暂无图片</div>
                            }
                        </Carousel>

                        <Card size="small" className="pad-card" headStyle={{ backgroundColor: '#F5F6FA' }}
                              bodyStyle={{ padding: 10 }}
                              title="注册信息">
                            <div className="pad-author">
                                <dl className="da-row">
                                    <dt className="ar-label">授权产品：</dt>
                                    <dd className="ar-body">{info.ppename}</dd>
                                </dl>
                                <dl className="da-row">
                                    <dt className="ar-label">授权商家：</dt>
                                    <dd className="ar-body">{info.merchant_name || ' - '}</dd>
                                </dl>
                                <dl className="da-row">
                                    <dt className="ar-label">授权数量：</dt>
                                    <dd className="ar-body">{info.accredit_num === 0 ? '不限' : (info.accredit_num + '件')}</dd>
                                </dl>
                                <dl className="da-row">
                                    <dt className="ar-label">授权期限：</dt>
                                    <dd className="ar-body">{info.is_long === '1' ? '长期' : ((info.accredit_start || '-')  + ' ~ ' + (info.accredit_end || '-'))}</dd>
                                </dl>
                                <dl className="da-row">
                                    <dt className="ar-label">采购方式：</dt>
                                    <dd className="ar-body">
                                        <span>{info.purchase_method === '1' ? '内部商城' : (info.purchase_method === '2' ? '年度内部' : ' - ')}</span>
                                        <span className="rb-link" onClick={() => this.handleToMall(info.id)}>
                                            前往购买 <Icon type="shopping-cart"/>
                                        </span>
                                    </dd>
                                </dl>
                            </div>
                        </Card>

                        <Card size="small" className="pad-card" headStyle={{ backgroundColor: '#F5F6FA' }}
                              bodyStyle={{ padding: 10 }}
                              title="产品参数">
                            <div className="pad-param">
                                <div className="dp-not">暂无内容</div>
                                {/*<div className="dp-item">品牌名称：旺旺；</div>*/}
                            </div>
                        </Card>

                        <Card size="small" className="pad-card" headStyle={{ backgroundColor: '#F5F6FA' }}
                              bodyStyle={{ padding: 10 }}
                              title="产品详情">
                            <p className="pad-detail">{info.ppedetail || ' - '}</p>
                        </Card>
                    </Spin>
                </Drawer>
            </div>
        )
    }
}

export default BNProAuthor



// WEBPACK FOOTER //
// ./src/routes/bottomNav/BNProAuthor.jsx